/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  hidePinForm,
  showPinForm,
} from 'containers/PinForm/actions/pinForm.actions';

import { Form } from 'cvlib';
import { getRemindControlPin } from 'containers/EPG/actions/channelBlocker/blocker.actions';

const RecoveryPinForm = () => {
  const dispatch = useDispatch();
  const translations = useSelector(state => state.translations);
  const email = useSelector(state => state.user.email);
  const remindControlPin = useSelector(
    state => state.cvEpg.channelBlocker.remindControlPin,
  );
  const translate = key =>
    translations[key] !== undefined ? translations[key] : key;

  const [correctEmail, setCorrectEmail] = useState(true);
  const [value, setValue] = useState('');

  useEffect(
    () => {
      if (remindControlPin.inProgress === false) {
        if (
          remindControlPin.success === true &&
          remindControlPin.data.email_sent
        ) {
          dispatch(showPinForm({ type: 'EMAIL_SENT' }));
        } else if (remindControlPin.error) {
          dispatch(
            showPinForm({
              type: 'ERROR',
              errorMessage: remindControlPin.error.message,
            }),
          );
        }
      }
    },
    [remindControlPin],
  );

  const elements = [
    {
      element: 'title',
      content: translate('lockChannel_access_title_label_getNip'),
      style: { paddingTop: '1.75rem' },
    },
    {
      element: 'subtitle',
      content: translate('lockChannel_access_subtitle_label_getNip'),
    },
    {
      element: 'item',
      type: 'email',
      placeholder: translate('login_access_placeHolder_textfield'),
      /* message: email_tooltip_valid_label_validation, */
      error:
        !correctEmail &&
        ((value.length === 0 && 'Debes llenar este campo') ||
          'Este correo no corresponde al correo del usuario administrador'),
      name: 'emailRecoverPin',
      id: 'emailRecoverPin',
      autoFocus: true,
      onChange: ({ target }) => {
        setCorrectEmail(target.value.length > 0);
        setValue(target.value);
      },
    },
    {
      element: 'message',
      content: translate('lockChannel_modal_option_label_close'),
    },
    {
      element: 'button',
      type: 'red',
      content: translate('lockChannel_access_option_button_getPIN'),
      onClick: () => {
        if (value === email) {
          dispatch(getRemindControlPin());
        } else {
          setCorrectEmail(false);
        }
      },
      style: { width: '288px' },
      className: 'redButton',
      expand: 5,
    },
    {
      element: 'button',
      type: 'gray',
      content: translate('lockChannel_access_option_button_cancel'),
      onClick: () => {
        dispatch(hidePinForm());
      },
      style: { width: '288px' },
      className: 'grayButton',
      expand: 5,
    },
  ];

  return <Form elements={elements} />;
};

export default RecoveryPinForm;
